module.exports = __webpack_public_path__ + "static/hughie-52e32af83e4b69a4a20d4cea2ff56e22.jpg";